/**
 * ToTheLove — #THLVbabe stories slider (peek + progress dots)
 */
class TtlLoveBabeSlider extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    this.track = this.querySelector('[data-ttl-babe-track]');
    this.slides = Array.from(this.querySelectorAll('[data-ttl-babe-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-ttl-babe-dot]'));
    this.index = 0;
    this.interval = Math.max(2000, Number(this.dataset.interval || 5000));
    this._timer = null;
    this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.style.setProperty('--ttl-babe-interval', `${this.interval}ms`);

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.dataset.index || 0);
        this.goTo(i, { restart: true });
      });
    });

    this.addEventListener('pointerenter', () => this.pause());
    this.addEventListener('pointerleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => {
      if (!this.contains(document.activeElement)) this.play();
    });

    if (this.slides.length > 1 && !this._reduced) this.play();
  }

  disconnectedCallback() {
    this.pause();
  }

  goTo(index, { restart = false } = {}) {
    if (!this.slides.length) return;
    const next = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    this.index = next;
    this.track.style.transform = `translate3d(-${next * 100}%, 0, 0)`;

    this.slides.forEach((slide, i) => {
      const active = i === next;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      const active = i === next;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
      // Restart CSS progress animation
      if (active && restart) {
        dot.classList.remove('is-active');
        void dot.offsetWidth;
        dot.classList.add('is-active');
      }
    });

    if (restart) this.play();
  }

  next() {
    this.goTo(this.index + 1, { restart: true });
  }

  play() {
    this.pause();
    if (this.slides.length < 2 || this._reduced) return;
    this._timer = window.setInterval(() => this.next(), this.interval);
  }

  pause() {
    if (this._timer) {
      window.clearInterval(this._timer);
      this._timer = null;
    }
  }
}

if (!customElements.get('ttl-love-babe-slider')) {
  customElements.define('ttl-love-babe-slider', TtlLoveBabeSlider);
}
